import localForage from "localforage/dist/localforage";
import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

let lastStoredSize = 0;
const vuexLocal = new VuexPersistence({
  storage: localForage,
  asyncStorage: true,
  modules: [
    "app",
    // "services",
    "ui",
    "persistedCache",
    // "pbxCalls",
    // "clientFleet",
    "clientMuteSoundPopover",
    "operators",
    // "clientServices",
    // "clientStops",
    // "clientSubscribers",
    // "clientTaxis",
    // "clientTrips",
    "clientUserRegisterData",
    // "clientZones",
    "clientQueues",
    "clientConfigs",
  ],
  // NOTE: This is a hack to check if the data has changed before storing it
  // not doing this end's up causing a memory leak probably because indexdb is not
  // capable of storing all data in time. Everytime something change in vuex this
  // functions are called regardless if the changes are in the modules that we are
  // registering here.
  restoreState: (key, storage) => {
    try {
      return Promise.resolve(storage.getItem(key));
    } catch (e) {
      return Promise.resolve();
    }
  },
  saveState: (key, state, storage) => {
    const data = JSON.stringify(state);
    const size = data.length;
    if (size != lastStoredSize) {
      lastStoredSize = size;
      return storage.setItem(key, state);
    }
    return Promise.resolve();
  },
  key: "vuex-storage",
});

import app from "./modules/app";
import errorLog from "./modules/errorLog";
import permission from "./modules/permission";
import settings from "./modules/settings";
import ui from "./modules/ui";
import version from "./modules/version";
import home from "./modules/views/home";

import applySanctionDialog from "./modules/applySanctionDialog";
import audioTripDialog from "./modules/audioTripDialog";
import callSomeoneDialog from "./modules/callSomeoneDialog";
import canalRadioDialog from "./modules/canalRadioDialog";
import detailMessageDialog from "./modules/detailMessageDialog";
import drivers from "./modules/drivers";
import newMessageDialog from "./modules/newMessageDialog";
import reqFormDialog from "./modules/reqFormDialog";
import reubicarExpulsar from "./modules/reubicarExpulsar";

// NEW MODULES PBX API
import pbxCalls from "./modules/pbx/calls";

// NEW MODULES CLIENT API
import cache from "./modules/cache";
import clientCalls from "./modules/client/calls";
import clientConfigs from "./modules/client/configs";
import clientCustomers from "./modules/client/customers";
import clientDeliveries from "./modules/client/deliveries";
import clientDrivers from "./modules/client/drivers";
import clientFleet from "./modules/client/fleet";
import clientHistoricTrips from "./modules/client/historic-trips";
import clientInvoices from "./modules/client/invoices";
import clientMessages from "./modules/client/messages";
import clientMuteSoundPopover from "./modules/client/mute-sound-popover";
import clientNotifications from "./modules/client/notifications";
import clientPrice from "./modules/client/price";
import clientQueues from "./modules/client/queues";
import clientReports from "./modules/client/reports";
import clientReqs from "./modules/client/reqs";
import clientServices from "./modules/client/services";
import clientStops from "./modules/client/stops";
import clientStopszones from "./modules/client/stopszones";
import clientStreets from "./modules/client/streets";
import clientSubscribers from "./modules/client/subscribers";
import clientSubscribersIndexTabs from "./modules/client/subscribersIndexTabs";
import clientSubscribersRemittances from "./modules/client/subscribersRemittances";
import clientTaxis from "./modules/client/taxis";
import clientTowns from "./modules/client/towns";
import clientTrips from "./modules/client/trips";
import clientTripsBilling from "./modules/client/trips-billing";
import clientUserRegisterData from "./modules/client/user-register-data";
import clientZones from "./modules/client/zones";
import operators from "./modules/operators";
import persistedCache from "./modules/persistedCache";
import services from "./modules/services";

import * as getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
  modules: {
    app,
    version,
    ui,
    home,
    services,
    cache,
    persistedCache,
    errorLog,
    permission,
    settings,

    drivers,
    reubicarExpulsar,
    canalRadioDialog,
    newMessageDialog,
    detailMessageDialog,
    applySanctionDialog,
    callSomeoneDialog,
    audioTripDialog,
    reqFormDialog,

    pbxCalls,
    clientCalls,
    clientConfigs,
    clientCustomers,
    clientDeliveries,
    clientDrivers,
    clientFleet,
    clientHistoricTrips,
    clientInvoices,
    clientMessages,
    clientMuteSoundPopover,
    clientNotifications,
    operators,
    clientPrice,
    clientReports,
    clientReqs,
    clientServices,
    clientStops,
    clientStopszones,
    clientStreets,
    clientSubscribers,
    clientSubscribersIndexTabs,
    clientSubscribersRemittances,
    clientTaxis,
    clientTowns,
    clientTripsBilling,
    clientTrips,
    clientUserRegisterData,
    clientZones,
    clientQueues,
  },
  plugins: [vuexLocal.plugin],
});

window.store = store;

export default store;
